import { BrowserClient, Hub } from '@sentry/browser';

let hub: Hub;

export const initializeSentry = (): void => {
    hub = new Hub(
        new BrowserClient({
            environment: process.env.REACT_APP_STAGE ?? 'prod',
            release: process.env.SENTRY_RELEASE,
            dsn: 'https://3d1329337ecc4281931bb5fcf7c3d5e2@sentry.io/5180738',
            sampleRate: 1,
        }),
    );
};

export const withSentryHub = (): Hub | undefined => {
    return hub;
};
